import "./MenuItemDivider.scss";

export default function MenuItemDivider() {
  return <hr className="menuDivider" />;
}
